import { CloseOutlined, EyeFilled, SyncOutlined } from '@ant-design/icons';
import { Badge, Button, Col, Modal, Row, Select, Tooltip } from 'antd';
import Table, { ColumnsType } from 'antd/es/table';
import ClientRequestsFillters, { filters } from 'components/filters/clientRequestsFillters';
import AddTicketModal from 'components/Modals/addTicketModal/AddTicketModal';
import PermissionsGate, { hasPermission } from 'components/permissionsGate';
import CustomTable from 'components/table';
import dayjs from 'dayjs';
import useKey from 'hooks/others/useKey';
import useProgressLoading from 'hooks/others/useProgressLoading';
import useClientRequests from 'hooks/query/clientRequests/useClientRequests';
import UseUpdateClientRequests from 'hooks/query/clientRequests/UseUpdateClientRequests';
import i18next, { t } from 'i18next';
import { ClientRequestsModel } from 'models/clientRequests';
import { UserModel } from 'models/users';
import ScheduledAppointments from 'pages/technicians/ScheduledAppointments';
import React, { useEffect, useState } from 'react'
import { AiOutlineSchedule } from 'react-icons/ai';
import { Link, useLocation } from 'react-router-dom';
import { useAppSelector } from 'store';
import format from 'utils/helpers/date-format';
import { UserData } from 'utils/helpers/encrypt-decrypt-user';
import Color from 'utils/helpers/export-sass-colors';
import { RequestClientStatus, Roles, Ticket, TicketKeyName } from 'utils/helpers/static_data';
import { StatusColor } from 'utils/helpers/ticket_status';
import useDidMountEffect from 'utils/helpers/use-did-mount-effect';

const { Option } = Select;
const firstOfYear = dayjs().startOf("year").format("YYYY-MM-DD");
const tommorrow = dayjs().add(1, "day").format("YYYY-MM-DD");
const defaultDateRange = `${firstOfYear},${tommorrow}`;

let CurrentPage = 1;
let CurrentFilters: filters & {
  DateRange: string;
  SearchText: string;
  SearchBy: string;
  dateFilterBy: string;
} = {
  Status: Ticket.create,
  requestStatus: RequestClientStatus.archived,
  Sort: "",
  Priority: "-1",
  isActive: 0,
  isPaused: 0,
  myClientRequests: 0,
  DateRange: defaultDateRange,
  SearchText: "",
  SearchBy: "ticket_id",
  dateFilterBy: "created",
};

const ClientRequestArchived = () => {
const location = useLocation();
const contractorId = Number(location.state?.contractorId);
const CompanyName = location.state?.CompanyName;

// console.log("CompanyName", typeof CompanyName)
// console.log("contractorId", typeof contractorId)

  const [Page, setPage] = useState(1);
  const [SearchText, setSearch] = useState<string>("");
  const [SearchBy, setSearchBy] = useState<string>("ticket_id"); //default search by
  const [filterBy, setFilterBy] = useState<string>("created");
  const [isActive, setIsActive] = useState<filters["isActive"]>(0);
  const [isPaused, setIsPaused] = useState<filters["isPaused"]>(0);
  const statusOptions = [
    { value: 15, status: t("new") },
    { value: 16, status: t("open") },
    { value: 17, status: t("closed") },
    { value: 18, status: t("verified") },
    { value: 19, status: t("request_paid") },
    { value: 20, status: t("archived") },
  ];

  const [myClientRequests, setMyClientRequests] =
    useState<filters["myClientRequests"]>(0);
  const [Status, setStatus] = useState<filters["Status"]>(
    // hasPermission(["browse_tickets"])
    //   ? Ticket.create
    //   : hasPermission(["browse_ticket_pending"])
    //   ? Ticket.pending
    //   : hasPermission(["browse_ticket_priced"])
    //   ? Ticket.priced
    //   : hasPermission(["browse_ticket_active"])
    //   ? Ticket.active
    //   : hasPermission(["browse_ticket_done"])
    //   ? Ticket.done
    //   : hasPermission(["browse_ticket_approved"])
    //   ? Ticket.approved
    //   : hasPermission(["browse_ticket_paid"])
    //   ? Ticket.paid
    //   : hasPermission(["browse_ticket_denied"])
    //   ? Ticket.denied
    //   : Ticket.create
  );
  const [requestStatus, setRequestStatus] = useState<filters["requestStatus"]>();
  const [Priority, setPriority] = useState<filters["Priority"]>("-1");
  const [DateRange, setDateRange] = useState(defaultDateRange);
  const [Sort, setSort] = useState<filters["Sort"]>("");

  const [ticketId, setTicketId] = useState<string>("");

  const [expandedRowKey, setExpandedRowKey] = useState(null);

  const [User, setUser] = useState<UserModel | null>(null);
  useEffect(() => {
    setUser(UserData.Decrypt());
  }, [UserData.Decrypt]);

  const [ticketsReqEnabled, setTicketReqEnabled] = useState<boolean>(false);

  const [addTicketModalIsOpen, setAddTicketModalIsOpen] = useState(false);
  const [ScheduleModalIsOpen, setScheduleModalIsOpen] = useState(false);

  const { data, isLoading, isFetching, refetch } = useClientRequests(
    Page,
    Status,
    20, //archivred
    Priority,
    DateRange,
    SearchBy,
    SearchText,
    isActive,
    Sort,
    "0",
    myClientRequests ?? 0,
    filterBy,
    isPaused!,
    contractorId || CompanyName
  );
const { mutate: updateClientRequest } = UseUpdateClientRequests();

  const progLoading = useProgressLoading({ isFetching });

  const { dataState: clientRequests } = useKey(data?.data);

  const columns: ColumnsType<ClientRequestsModel> = [
    {
      title: t("client_request_id"),
      dataIndex: ["id"],
      render: (data: any, obj: ClientRequestsModel) =>
        obj.type == "contract" ? (
          <Badge.Ribbon
            text={t("contract")}
            color="#FBC02D"
            placement="start"
            style={{
              background: "rgb(251, 192, 45)",
              position: "absolute",
              top: "-20px",
              left: i18next.language === "ar" ? "" : "-7px",
              right: i18next.language === "ar" ? "1px" : "",
            }}
          >
            <Tooltip
              title={`${obj.contract_start_date} - ${obj.contract_end_date}`}
              color="white"
              placement={i18next.language === "ar" ? "left" : "right"}
            >
              <div
                style={{
                  color: "white",
                  backgroundColor:
                    obj.requested_by.id == obj.created_by.id
                      ? Color.blue_4
                      : Color.blue_2,
                  borderRadius: "8px",
                  marginRight: "0.5rem",
                  minWidth: "70px",
                  display: "block",
                }}
              >
                {obj.id}
              </div>
            </Tooltip>
          </Badge.Ribbon>
        ) : (
          <Tooltip
            title={
              obj.created_by.id == obj.requested_by.id
                ? t("requested by client")
                : ""
            }
            color="white"
            placement={i18next.language === "ar" ? "left" : "right"}
          >
            <span
              style={{
                color: "white",
                backgroundColor:
                  obj.requested_by.id == obj.created_by.id
                    ? Color.blue_4
                    : Color.blue_2,
                borderRadius: "8px",
                marginRight: "0.5rem",
                minWidth: "70px",
                display: "block",
              }}
              dir="ltr"
            >
              {obj.id}
            </span>
          </Tooltip>
        ),
    },
    {
      title: t("client_request_title"),
      dataIndex: "title",
      render: (title: ClientRequestsModel["title"]) => (
        <div>
          {title ? title : "-"}
        </div>
      ),
    },
    {
      title: t("request_creator_by"),
      dataIndex: "created_by",
      render: (created_by: ClientRequestsModel["created_by"]) => (
        <div>
          {created_by?.full_name !== null &&
            created_by?.full_name !== undefined &&
            created_by?.full_name}
        </div>
      ),
    },
    {
      title: t("created_at"),
      dataIndex: "created_at",
      render: (created_at: ClientRequestsModel["created_at"]) => (
        <span dir="ltr">{dayjs(created_at).format(format.date_time)}</span>
      ),
    },
    {
      title: <span>{t("category_name")}</span>,
      render: (data: ClientRequestsModel) => (
        <span>
          {data.company_place
            ? data?.company_place?.company?.classification?.name
            : t("contractor")}
        </span>
      ),
    },
    {
      title: (
        <span style={{ display: "inline-block", marginLeft: "6px" }}>
          {t("customer")}
        </span>
      ),
      dataIndex: "",
      render: (data: ClientRequestsModel) => {
        const name = data?.company_place?.company
          ? i18next.language === "ar"
            ? data?.company_place?.company?.name_ar
              ? data.company_place.company.name_ar
              : data.company_place.company.name_en
            : data?.company_place?.company?.name_en
            ? data.company_place.company.name_en
            : data.company_place.company.name_ar
          : data?.requested_by?.full_name;

        return <div>{name}</div>;
      },
    },
    {
      title: t("total_tickets"),
      dataIndex: "total_tickets",
      width: "10%",
      render: (total_tickets) => <span>{total_tickets}</span>,
    },
    {
      title: t("status"),
      dataIndex: "status",
      render: (status: any, data: ClientRequestsModel) => (
        <div
          className={`statusBtn status${status.id}`}
          style={{
            textTransform: "capitalize",
            fontSize: "12px",
            whiteSpace: "nowrap",
          }}
        >
          {Ticket.paid === status.id.toString() &&
          User?.role_id === Roles.client
            ? TicketKeyName.paidClient
            : status.status}{" "}
          {data.partial_status ? t("partially") : ""}
        </div>
      ),
    },
    // {
    //   title: t("chnage_request_status"),
    //   dataIndex: "status",
    //   render: (status: any, data: ClientRequestsModel) => {
    //     return (
    //       <Select
    //         style={{ minWidth: 140 }}
    //         value={
    //           status.id === 15 || 
    //           status.id === 16 || 
    //           status.id === 17 || 
    //           status.id === 18 ||
    //           status.id === 19 || 
    //           status.id === 20 ? status.id : "-"
    //         }
    //         onClick={(e) => {
    //           e.stopPropagation();
    //         }}
    //         onChange={(clientRequestStatusId) => {
    //           if(Number(clientRequestStatusId) === status.id) return
    //           else {
    //             console.log(status.status);
    //             handlechangeStatus(clientRequestStatusId, data.id);
    //           }
    //         }}          
    //       >
    //         {statusOptions.map((item) =>
    //           (
    //           <Option
    //             key={item.value}
    //             value={item.value}
    //             label={item.status}
    //           >
    //             {item.status}
    //           </Option>
    //         ))}
    //       </Select>
    //     );
    //   }
    // },
    {
      title: (
        <span className="tickets_count">
          {t("requests_count")}{" "}
          {!isLoading && data?.meta?.total !== undefined
            ? data?.meta?.total
            : "0"}
        </span>
      ),
      dataIndex: ["id"],
      render: (id: any, obj: ClientRequestsModel) => (
        <PermissionsGate scopes={["read_tickets"]}>
          <Link
            className="ticketLink"
            to={{
              pathname: `/client-requests/${obj.id}`,
            }}
          >
            <span className={"seeTicket"}>
              <EyeFilled />
              {obj.total_notification !== null &&
                obj.total_notification !== 0 && (
                  <span className="notificationNum">
                    {obj?.total_notification}
                  </span>
                )}
            </span>
          </Link>
        </PermissionsGate>
      ),
    },
    Table.EXPAND_COLUMN,
  ];

  const deviceColumns: ColumnsType<ClientRequestsModel> = [
    {
      title: "Client Requests",
      render: (obj: ClientRequestsModel) => {
        const customerName = obj?.company_place?.company
          ? i18next.language === "ar"
            ? obj?.company_place?.company?.name_ar
              ? obj.company_place.company.name_ar
              : obj.company_place.company.name_en
            : obj?.company_place?.company?.name_en
            ? obj.company_place.company.name_en
            : obj.company_place.company.name_ar
          : obj?.requested_by?.full_name;
        return (
          <div
            style={{
              border: `3px solid ${StatusColor(obj.status.id)}`,
              padding: "0",
            }}
            className="mobileCard"
          >
            <div className="label">
              <>
                <div
                  className={"statusBtn status" + obj.status.id}
                  style={{
                    borderRadius: "0 0 50% 50%",
                    textTransform: "capitalize",
                  }}
                >
                  {Ticket.paid === obj.status.id.toString() &&
                  User?.role_id === Roles.client
                    ? TicketKeyName.paidClient
                    : obj.status.status}
                </div>
              </>
            </div>
            <Row style={{ padding: "20px", paddingTop: "0" }}>
              <Col md={12} span={24}>
                <div className="label">
                  <span>{t("client_request_id")}</span>
                  <span
                    style={{
                      backgroundColor:
                        obj.created_by?.company === null &&
                        !obj.created_by?.is_verified &&
                        User?.role_id !== Roles.client
                          ? `#FBC02D77`
                          : `${StatusColor(obj.status.id)}77`,
                      width: "fit-content",
                      padding: "7px",
                      borderRadius: "50%",
                    }}
                  >
                    {obj.id}
                  </span>
                </div>
              </Col>
              <Col md={12} span={24}>
                <div className="label">
                  <span> {t("request_creator_by")} :</span>
                  {obj.created_by?.full_name !== null &&
                    obj.created_by?.full_name !== undefined &&
                    obj.created_by?.full_name}
                </div>
              </Col>
              <Col md={12} span={24}>
                <div className="label">
                  <span> {t("created_at")} :</span>
                  <span dir="ltr">
                    {dayjs(obj?.created_at).format(format.date_time)}
                  </span>
                </div>
              </Col>
              <Col md={12} span={24}>
                <div className="label">
                  <span> {t("category_name")} :</span>
                  {!obj?.company_place
                    ? t("contractor")
                    : obj?.company_place?.company?.classification.name
                    ? obj?.company_place?.company?.classification.name
                    : obj?.company_place?.company?.classification.name_en}
                </div>
              </Col>
              <Col md={12} span={24}>
                <div className="label">
                  <span> {t("customer")} :</span>
                  {customerName}
                </div>
              </Col>
              <Col md={12} span={24}>
                <div className="label">
                  <span> {t("tickets_count")} :</span>
                  <span style={{ textAlign: "center" }}>
                    {obj.total_tickets}
                  </span>
                </div>
              </Col>
              {/* <Col md={12} span={24}>
                <div className="label">
                  <span> {t("chnage_request_status")} :</span>
                  <Select
                    style={{ minWidth: 140 }}
                    value={
                      obj.status.id === 15 || 
                      obj.status.id === 16 || 
                      obj.status.id === 17 || 
                      obj.status.id === 18 ||
                      obj.status.id === 19 || 
                      obj.status.id === 20 ? obj.status.id : "-"
                    }
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onChange={(clientRequestStatusId) => {
                      if(Number(clientRequestStatusId) === obj.status.id) return
                      else {
                        console.log(obj.status.status);
                        handlechangeStatus(clientRequestStatusId, obj.id);
                      }
                    }}          
                  >
                    {statusOptions.map((item) =>
                      (
                      <Option
                        key={item.value}
                        value={item.value}
                        label={item.status}
                      >
                        {item.status}
                      </Option>
                    ))}
                  </Select>
                </div>
              </Col> */}
              <Col span={24}>
                <PermissionsGate scopes={["read_tickets"]}>
                  <Link
                    className="ticketLink"
                    to={{
                      pathname: `/client-requests/${obj.id}`,
                    }}
                  >
                    <span style={{ marginTop: "0" }} className={"seeTicket"}>
                      <EyeFilled />
                      {t("view_request")}
                      {obj.total_notification !== null &&
                        obj.total_notification !== 0 && (
                          <span className="notificationNum">
                            {obj?.total_notification}
                          </span>
                        )}
                    </span>
                  </Link>
                </PermissionsGate>
              </Col>
            </Row>
          </div>
        );
      },
    },
  ];
  const isLoggedIn = useAppSelector((state) => state.auth.isLoggedIn);

  const handlechangeStatus = (clientRequestStatusId: any, clientRequestId: any) => {
    console.log(clientRequestStatusId,clientRequestId);
    updateClientRequest({clientRequestStatusId,clientRequestId});
  }

  useDidMountEffect(() => {
    CurrentPage = 1;
    CurrentFilters = {
      Status: Ticket.create,
      requestStatus: RequestClientStatus.create,
      Sort: "",
      Priority: "-1",
      isActive: 0,
      isPaused: 0,
      myClientRequests: 0,
      DateRange: defaultDateRange,
      SearchText: "",
      SearchBy: "ticket_id",
      dateFilterBy: "created",
    };
  }, [isLoggedIn]);

  useEffect(() => {
    setPage(CurrentPage);
  }, [
    Status,
    requestStatus,
    Priority,
    DateRange,
    SearchText,
    isActive,
    isPaused,
    myClientRequests,
    Sort,
  ]);

  useEffect(() => {
    setStatus(CurrentFilters.Status);
    setRequestStatus(CurrentFilters.requestStatus);
    setSort(CurrentFilters.Sort);
    setPriority(CurrentFilters.Priority);
    setIsActive(CurrentFilters.isActive);
    setIsPaused(CurrentFilters.isPaused);
    setMyClientRequests(CurrentFilters.myClientRequests);
    setDateRange(CurrentFilters.DateRange);
    setSearch(CurrentFilters.SearchText);
    setSearchBy(CurrentFilters.SearchBy);
  }, [location.pathname]);

  const changePage = (e: any) => {
    setPage(e);
    CurrentPage = e;
  };

  const onExpand = (expanded: boolean, record: any) => {
    if (expanded) {
      setExpandedRowKey(record.key);
    } else {
      setExpandedRowKey(null);
    }
    setTicketId(record.id);
    setTicketReqEnabled(true);
  };

  useEffect(() => {
    setExpandedRowKey(null);
  }, [Status, requestStatus, Sort, SearchText, DateRange, Page, isActive,isPaused]);

  function handleClickFilters() {
    setStatus(Ticket.create);
    setRequestStatus(RequestClientStatus.create);
    setSort("");
    setPriority("-1");
    setIsActive(0);
    setIsPaused(0);
    setMyClientRequests(0);
    setDateRange(defaultDateRange);
    setSearch("");
    setSearchBy("ticket_id");

    CurrentFilters = {
      Status: Ticket.create,
      Sort: "",
      Priority: "-1",
      isActive: 0,
      myClientRequests: 0,
      isPaused:0,
      DateRange: defaultDateRange,
      SearchText: "",
      SearchBy: "ticket_id",
      dateFilterBy: "created",
    };
  }

  const showClearFiltersBtn =
    Status !== Ticket.create ||
    requestStatus !== RequestClientStatus.create ||
    DateRange !== defaultDateRange ||
    SearchText !== "" ||
    isActive !== 0 ||
    isPaused !== 0 ||
    myClientRequests !== 0 ||
    Sort !== "" ||
    Priority !== "-1" ||
    SearchBy !== "ticket_id";

  return (
    <div className="tickets">
      {!showClearFiltersBtn && (
        <div style={{ marginBottom: "12px",}}></div>
      )}
      {showClearFiltersBtn && (
        <Button
          icon={<CloseOutlined />}
          style={{ marginBottom: "12px", fontSize: "13px" }}
          onClick={handleClickFilters}
          size="small"
        >
          {t("reset_filters")}
        </Button>
      )}
      <div className="altTicketBtns">
        <div className="actionBtns">
          {User?.role_id == Roles.technical &&
            setScheduleModalIsOpen &&
            hasPermission(["browse_schedules"]) && (
              <Button
                type="primary"
                onClick={() => setScheduleModalIsOpen(true)}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <AiOutlineSchedule />
                  <p style={{ margin: 0 }}>{t("appointments")}</p>
                </div>
              </Button>
            )}
        </div>

        <ClientRequestsFillters
        //   Status={Status}
        //   requestStatus={requestStatus}
          Priority={Priority}
        //   Sort={Sort}
        //   isActive={isActive}
        //   isPaused={isPaused}
          myClientRequests={myClientRequests}
          DateRange={DateRange}
          SearchText={SearchText}
          SearchBy={SearchBy}
          dateFilterBy={filterBy}
          setDateFilterBy={setFilterBy}
        //   setStatus={(status: filters["Status"]) => {
        //     CurrentPage = 1;
        //     setStatus(status);
        //     CurrentFilters.Status = status;
        //   }}
        //   setRequestStatus={(requestStatus: filters["requestStatus"]) => {
        //     CurrentPage = 1;
        //     setRequestStatus(requestStatus);
        //     CurrentFilters.requestStatus = requestStatus;
        //   }}
          setPriority={(priority: filters["Priority"]) => {
            CurrentPage = 1;
            setPriority(priority);
            CurrentFilters.Priority = priority;
          }}
        //   setSort={(sort: filters["Sort"]) => {
        //     CurrentPage = 1;
        //     setSort(sort);
        //     CurrentFilters.Sort = sort;
        //   }}
        //   setIsActive={(active: filters["isActive"]) => {
        //     CurrentPage = 1;
        //     setIsActive(active);
        //     CurrentFilters.isActive = active;
        //   }}
        //   setIsPaused={(paused: filters["isPaused"]) => {
        //     CurrentPage = 1;
        //     setIsPaused(paused);
        //     CurrentFilters.isPaused = paused;
        //   }}
          setMyClientRequests={(my: filters["myClientRequests"]) => {
            CurrentPage = 1;
            setMyClientRequests(my);
            CurrentFilters.myClientRequests = my;
          }}
          multiSearch={User?.role_id === Roles.client ? undefined : "ticket"}
          setSearch={(search: string) => {
            CurrentPage = 1;
            setSearch(search);
            CurrentFilters.SearchText = search;
          }}
          setSearchBy={(searchBy: string) => {
            CurrentPage = 1;
            setSearchBy(searchBy);
            CurrentFilters.SearchBy = searchBy;
          }}
          setDate={(date: any) => {
            CurrentPage = 1;
            setDateRange(date);
            CurrentFilters.DateRange = date;
          }}
          isFetching={isFetching}
          arrchived= {1}
        />
      </div>
      <CustomTable
        isLoading={isLoading}
        columns={columns}
        mobileColumns={deviceColumns}
        dataSource={clientRequests}
        page={(e) => changePage(e)}
        current={Page}
        totalPage={data && data.meta && (data?.meta?.total as any)}
        isExpandable={true}
        onExpand={onExpand}
        expandedRowKey={expandedRowKey}
        ticketId={ticketId}
        ticketStatus={Status}
        enabled={ticketsReqEnabled}
        linearLoading={progLoading}
      />
      <AddTicketModal
        isOpen={addTicketModalIsOpen}
        setIsOpen={setAddTicketModalIsOpen}
      />
      <Modal
        open={ScheduleModalIsOpen}
        width={1400}
        onCancel={() => setScheduleModalIsOpen(false)}
        bodyStyle={{
          padding: "3rem",
          backgroundColor: "#f4f4f4",
          maxHeight: "80vh",
          overflowY: "scroll",
        }}
        closable={false}
        centered
        footer={null}
      >
        <ScheduledAppointments />
      </Modal>
    </div>
  );
}

export default ClientRequestArchived